import { useEffect, useState } from 'react';
import { JSONContent } from '@tiptap/core';

import type { AnswerFragment } from '../../present/activity-answers.graphql.generated';
import { useRichtext } from 'approot/shared/richtext/richtext.hooks';
import { BORDER_STYLE_NONE } from 'global/constants';
import Richtext from 'approot/shared/richtext/richtext';
import { getInitialContent } from 'approot/shared/richtext/get-initial-richtext-data';
import { getRichtextAnswer } from '../shared/logic/get-richtext-answer';
import { ResponseBox, ResponseField } from '../response/response-view.style';
import { DISCUSSION_TEXT_RESPONSE_SETTINGS } from './discussion-view.constants';

const DiscussionTextResponse = ({
  answer,
  baseHeight,
  onChange,
}: {
  answer: null | AnswerFragment | undefined;
  baseHeight: number;
  onChange?: (content: JSONContent) => void;
}) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const { editor, toolbarRef } = useRichtext({
    initialValue: getInitialContent({
      initialValue: getRichtextAnswer(answer),
      settings: DISCUSSION_TEXT_RESPONSE_SETTINGS,
    }),
    onChange: json => onChange?.(json),
    onFocus: () => setIsEditing(true),
    onBlur: () => setIsEditing(false),
    settings: DISCUSSION_TEXT_RESPONSE_SETTINGS,
  });

  useEffect(() => {
    // answers come in separately, only initialise once
    if (answer && !isEditing) {
      const editorContent = getInitialContent({
        initialValue: getRichtextAnswer(answer),
        settings: DISCUSSION_TEXT_RESPONSE_SETTINGS,
      });
      editor?.commands.setContent(
        editorContent
          ? editorContent
          : {
              type: 'doc',
              content: [],
            }
      );
    }
  }, [answer, isEditing, editor]);

  return (
    <ResponseBox variant={BORDER_STYLE_NONE}>
      <ResponseField $numberOflines={1} $baseHeight={baseHeight}>
        {editor && <Richtext editor={editor} toolbarRef={toolbarRef} />}
      </ResponseField>
    </ResponseBox>
  );
};

export default DiscussionTextResponse;
